
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "get-geocoder-geoid",
      resolverType: "query",
      routePath: "/get-geocoder-geoid",
      httpMethod: "POST",
    });
  